import { Component, Input } from '@angular/core';

@Component({
  selector: 'tangram-question-analytics-panel',
  templateUrl: './question-analytics-panel.component.html',
  styleUrls: ['./question-analytics-panel.component.scss']
})
export class QuestionAnalyticsPanelComponent {
  @Input() questionInsights: Array<{ topic: string; sample: string; count: number }> = [];
}
